const earningsDrilldownHR = {
    "view": {
        "form": {
            "label": {
                "filters": "Filteri",
                "monthRange": "Raspon Mjeseci",
                "startingMonth": "Početni Mjesec",
                "endingMonth": "Završni Mjesec",
                "label": "Labela",
                "store": "Trgovina",
                "release": "Izdanja",
                "track": "Pjesma",
                "country": "Država",
                "subuser": "Podkorisnik",
                "fetchingEarnings": "Dohvaćanje statistike zarade iz baze podataka"
            },
            "button": {
                "generateReport": "Generiraj Izvještaj",
                "resetFilters": "Resetiraj Filtere"
            },
            "options": {
                "store": {
                    "selectStore": "Odaberi Trgovinu",
                    "allStores": "Sve Trgovine"
                },
                "label": {
                    "selectLabel": "Odaberi Labelu"
                },
                "country": {
                    "allCountries": "Sve Države"
                },
                "release": {
                    "allReleases": "Sva Izdanja"
                },
                "track": {
                    "allTracks": "Sve Pjesme"
                },
                "subuser": {
                    "selectSubuser": "Odaberi Podkorisnika"
                },
                "period": {
                    "selectMonthRange": "Odaberi Raspon Mjeseci",
                    "last3Reports": "Posljednja 3 Izvještaja",
                    "last6Reports": "Posljednja 6 Izvještaja",
                    "last12Reports": "Posljednja 12 Izvještaja",
                    "custom": "Prilagođeno"
                }
            },
            "validation": {
                "monthRangeRequired": "* Filter za Raspon Mjeseci je obavezan",
                "labelRequired": "* Filter za Labelu je obavezan"
            }
        },
        "royaltiesSummary": {
            "title": "Sažetak Tantijema",
            "subtitle": "Pregled odabranog Raspona Mjeseci",
            "label": {
                "monthRangeText": "Posljednjih 12 Izjava",
                "revenueEUR": "Prihod (€)",
                "combinedRevenue": "Kombinirani Prihod",
                "combinedRevenueEUR": "Kombinirani Prihod (€)",
                "otherStores": "Ostale Trgovine"
            }
        },
        "storeWiseRevenuePercentage": {
            "title": "Postotak Prihoda po Trgovinama"
        },
        "storeWiseRevenueBreakdown": {
            "title": "Razdioba Prihoda po Trgovinama",
            "label": {
                "revenue": "Prihod"
            }
        },
        "revenueByTerritory": {
            "title": "Prihod po Teritoriju"
        },
        "top5Releases": {
            "title": "Top 5 Izdanja",
            "table": {
                "column": {
                    "releaseName": "Naziv Izdanja",
                    "revenue": "Prihod"
                }
            }
        },
        "top5Tracks": {
            "title": "Top 5 Pjesama",
            "table": {
                "column": {
                    "trackName": "Naziv Pjesme",
                    "revenue": "Prihod"
                }
            }
        },
        "message": {
            "noAccess": "Nemate pristup ovom modulu, molimo kontaktirajte podršku za više informacija.",
            "subscriptionExpired": "Vaša pretplata je istekla. Molimo <1>obnovite</1> svoju pretplatu kako biste koristili ovu značajku.",
            "subscriptionUpgrade": "Vaš trenutni plan pretplate ne podržava ovu značajku. Molimo <1>nadogradite</1> svoj plan pretplate kako biste koristili ovu značajku."
        }
    }
};

export default earningsDrilldownHR;